import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";

const addReview = body => {
  // const endpoint = `${config.baseUrl}/api/tb/restaurants/update`;
  // const endpoint = "https://www.foodiestrip.com/api/tb/restaurants/update";
  const xsrfToken = getFreshToken();
  const endpoint = `${config.baseUrl}/api/review`;
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include",
    body: JSON.stringify(body)
  };
  return fetch(endpoint, options)
    .then(response => {
      return response.json();
    })
    .then(response => {
      // if (
      //   response.error &&
      //   response.error.status &&
      //   response.error.status === 401
      // ) {
      //   window.location.href = config.login;
      // }
      if (response && response.restaurants && response.restaurants.length > 0) {
        return response.restaurants;
      }
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default addReview;
